import React from "react"
import { Tweet } from "react-twitter-widgets"
import useMediaQuery from '@material-ui/core/useMediaQuery';

const NextBase = () => {
  const isDesktopOrLaptop = useMediaQuery('(min-width:1224px)')
    return (
        <div style={{
            width: '70vw',
            fontSize: isDesktopOrLaptop ? '5vw' : '6vw',
            fontWeight: '700',
            justifyContent: 'left',
            textAlign: 'left',
            marginBottom: "5vh",
            color: '#3c3c5d'
        }}>
            次回のプラサミ
            <hr style={{ height: "2px", marginBottom: "5vh" }} />
            <div style={{
                marginBottom: isDesktopOrLaptop ? '5vh' : 0,
                fontSize: isDesktopOrLaptop ? '2.5vw' : '3.7vw',
                fontWeight: '600'
            }}
            >
                次回プラサミは下記ツイートの日程を予定していたのですが、<br />
                コロナウイルスの影響により絶賛延期中です...(๑•̥ૅㅁ•̥๑) <br />
                いずれまた開催するので皆様コロナ明けにはぜひともご参加のほど、そして<br />
                その日まで何卒お身体にお気を付けて精進のほどを...(๑•̥ૅㅁ•̥๑)
                <Tweet tweetId="1242807244565041153" options={{ theme: "dark", width: '450', height: '200' }} />
            </div>
        </div >
    )
}

export default NextBase;